var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spanish",
    transform: "translate(21301 -2786)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21301 2786)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M7.837,2.106h-11.4V9.823H9.816v4.769H-9.5V-14.219H9.776V-9.41H-3.561v6.866h11.4ZM24.518,8.676a1.843,1.843,0,0,0-1.039-1.652,11.8,11.8,0,0,0-3.334-1.078q-7.638-1.6-7.638-6.49A5.883,5.883,0,0,1,14.871-5.3a9.539,9.539,0,0,1,6.184-1.91,10.266,10.266,0,0,1,6.52,1.919A6.049,6.049,0,0,1,30.019-.308H24.3a2.767,2.767,0,0,0-.792-2.028,3.35,3.35,0,0,0-2.473-.8,3.423,3.423,0,0,0-2.236.653,2.061,2.061,0,0,0-.792,1.662,1.762,1.762,0,0,0,.9,1.534A9.262,9.262,0,0,0,21.945,1.72a24.809,24.809,0,0,1,3.6.96q4.531,1.662,4.531,5.758a5.585,5.585,0,0,1-2.513,4.739,10.841,10.841,0,0,1-6.49,1.811,11.323,11.323,0,0,1-4.779-.96A8.018,8.018,0,0,1,13.021,11.4a6.115,6.115,0,0,1-1.187-3.611h5.422a2.985,2.985,0,0,0,1.128,2.335,4.474,4.474,0,0,0,2.81.811,4.141,4.141,0,0,0,2.483-.623A1.94,1.94,0,0,0,24.518,8.676Z",
    transform: "translate(-21266.021 2830.604)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/Spanish.de23f398.svg";
export { ForwardRef as ReactComponent };